import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { datadogRum } from '@datadog/browser-rum';
import { catchError, throwError } from 'rxjs';

function sanitizeUrl(value: string): string {
  const url = new URL(value, window.location.origin);
  url.search = '';
  url.hash = '';
  url.username = '';
  url.password = '';
  return url.href;
}

export const rumHttpErrorInterceptor: HttpInterceptorFn = (request, next) =>
  next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const safeUrl = sanitizeUrl(request.url);
        const rumError = new Error(
          `[HTTP] ${request.method} ${safeUrl} returned ${error.status}`,
        );
        rumError.name = 'HttpErrorResponse';

        datadogRum.addError(rumError, {
          source: 'network',
          request: {
            method: request.method,
            url: safeUrl,
            status: error.status,
          },
        });
      }

      return throwError(() => error);
    }),
  );